const CUSTOMER_DATA = ['客户呼入：创建时间为当前时间，客户来源为广告呼入的客户数量；', '工单数量：当前时间创建工单的数量；']

const RECOMMEND = ['人选推荐漏斗分析个流程数据转化情况，数据来源于绩效审核；','推荐面试比  = 客户面试数 / 推给客户数','面试offer比 = offer人数  / 客户面试数','offer入职比 = 成功入职  / offer 人数'];

const MONTH_COLLECTION = ['记录当前时间内回款数据变化；'];

const EMPLOYEE_DATE = ['员工总数:当前时间在职员工总人数；', '离职员工：当前时间内离职员工人数；', '入职员工：当前时间内入职员工人数；'];

const COLLECTION_GRDE = ['有过回款记录的客户等级分布情况；', 'V0：回款低于10万以下的客户数量；', 'V1-V2：回款10万~40万内的客户数量；', 'V3~V4：回款40万~100万内的客户数量；', 'V5： 回款100万以上的客户数量；'];

const RESUME_Date = ['员工录入：由顾问录入的简历数量统计；', '会员注册：C端人选主动注册锐仕方达网站并录入简历的数量；'];

const COLLECTION_REGION = ['当前时间范围回款客户地域分布，区域数量越多，地图颜色越突出；'];

const COLLECTION_INDUSTRY = ['当前时间范围回款客户行业分布情况；'];

const COLLECTION_MONEY = ['当前时间范围内回款客户回款金额的分布情况；'];

const COLLECTION_CYCLE = ['不同等级客户的（客户第一次回款时间 - 客户签约时间）/  第一次回款的客户总个数；', '例如：A客户第一回款时间是12月1日，签约时间是10月1日；B客户第一次回款时间是11月15日，签约时间是11月1日；', '计算方式为：[(A客户回款时间-A客户签约时间)+(B客户回款时间-B客户签约时间)] / 2；'];

const ACHIEVEMENT_DISTRIBUTION = ['当前时间范围内业绩分布，当前时间范围业绩完成进度情况；'];

const CANDIDATE_RECOMMENDATION = ['当前时间范围 推荐、面试、offer、入职趋势；'];

const RECOMMENDED_FUNNEL = ['人选推荐漏斗分析个流程数据转化情况，数据来源于绩效审核；','推荐面试比  = 客户面试数 / 推给客户数','面试offer比 = offer人数  / 客户面试数','offer入职比 = 成功入职  / offer 人数'];

const BUSINESS_CONSULTANT = ['当前时间范围参与业绩分配顾问的职位分布及子该职位中回款金额分布、业绩金额分布情况；', '管理岗：大区总、VP；', '中级业务岗：合伙人、资深顾问、猎头顾问', '初级业务岗：实习顾问，助理；', '其他岗：职能部门岗位；'];

const BUSINESS_EDUCATION = ['业务顾问学历分布情况；']; 

const BUSINESS_AGE = ['业务顾问年龄分布情况；'];

const BUSINESS_WORK_YEAR = ['业务顾问工龄分布情况；'];

const BUSINESS_SEX = ['LV0=业绩小于1W','LV1=业绩1W-15W之间','LV2=业绩15W-30W之间','LV3=业绩30W-50W之间','LV4=业绩50W-100W之间','LV5及以上=业绩大于100W'];

const BUSINESS_HOUSEHOLD_REGISTER = ['业务顾问户籍状况分布情况；'];

const MANAGEMENT_STAFF = ['员工开单周期： 当前时间入职的员工 且发过offer的员工数（员工发offer时间 -  员工入职时间）员工个数', '当前时间范围：员工人数与业绩数据折线图', '1、在职人数折线在上，说明未完成对应平均业绩，人员处于偏离状态', '2、完成业绩折线在上，说明未完成对应平均招聘目标，业绩处于偏离状态']; 

const MANAGEMENT_COMPANY = ['满足对应业绩金额的公司个数分布情况；']; 

const MANAGEMENT_GRADE = ['有过回款记录的客户等级分布情况：', 'V0：回款低于10万以下的客户数量；', 'V1-V2：回款10万~40万内的客户数量；', 'V3~V4：回款40万~100万内的客户数量；', 'V5： 回款100万以上的客户数量；']; 

const MANAGEMENT_PRICE = ['客单价/人效诊断：', '1、入职中位线与回款中位线交叉点说明客户的性价比最高；', '2、气泡面积越大说明客单价越高；']; 

const MANAGEMENT_ALL = ['员工目标：年度制定的员工目标人数；', '入职：当前时间入职的员工数；', '离职：当前时间离职的员工数；', '实际在职：截止当前时间在职员工人数；']; 

const MANAGEMENT_STAFF_GRADE = ['在职员工职级分布情况：', 'C/SC资深顾问、猎头顾问；', 'AC实习顾问；', 'R助理；', 'P合伙人；']; 

const MANAGEMENT_EDUCATION = ['在职员工学历分布情况；'];

const MANAGEMENT_QUIT = ['工龄在时间范围的离职员工个数；'];

const MANAGEMENT_INFO = ['回款金额：当前时间回款金额；', '客户回款周期：（客户回款到账时间 - 客户签约时间 ） / 回款客户个数 ， 例如2021年，签约的客户已回款 ，减去签约时间，除以签约客户数，算出平均回款周期；', '客户复签率：例如历史合同到期的客户，在当期继续签约的客户为复签客户， 复签率 = 复签客户个数/ 历史签约客户个数；', '人均单产=公司年度业绩总和/（所有人员的在职系数加和）；每个人的年度在职系数=在职天数/365；每个人指的是年度内曾经存在的所有人，包括离职员工。','按照这个算法，比如 算今年单产，我今年入职1年 按1计算 ，另一个人在职6个月，按180/365 , 业绩是2万的，20000/(1+180/365) ，这里面包含当前时间内离职员工', '职位交付周期：统计有交付人选的职位，{[（单个人选交付时间 - 创建职位时间）总时间 ] / 交付人选个数 } / 职位个数；', '员工开单周期： 当前时间入职的员工 且发过offer的员工数（员工发offer时间 -  员工入职时间）员工个数；'];

const YJTB_DATA = ['业绩同比增长率=(本期业绩数-同期业绩数)÷同期业绩数×100%'];

const KDJ_Data = ['offer客单价=offer总金额/offer数量'];

const ZHL_DATA = ['推荐面试比= 面试量/offer量','面试offer比=offer量/面试量','推荐offer比=offer量/推荐量'];

const YSZC_DATA = ['营收支出比系数=当期营收/当期支出，指每支出1元能创造多少收入','支出营收比系数=当期支出/当期营收，指每创造1元收入需要支出多少钱'];

const YJWCL_DATA = ['业绩完成率=实际完成业绩/年度业绩目标'];

const QYGCDB_DATA = ['区域总的推荐数、面试数、offer数、offer金额（系统-绩效管理-观星盘中可查）'];

const KHZS_DATA = ['显示各区域（新签+续签）客户总数'];

// const KHDJ_DATA = ['某等级客户占比=此等级客户数量/所有客户数量'];

const QURYTBZC_DATA = ['人员同比增长率=(本期底在职人数-同期底在职人数)÷同期底在职人数'];

const QYJZ_DATA = ['净增=入职人数-离职人数'];

const RX_DATA = ['人效=当期累计业绩/周期底在职人数（含公司所有员工）'];

const JDZPLCL_DATA = ['招聘留存率=当期入职且现仍在职人数/当期入职人数'];

const LZTHL_DATA = ['离职替换率=离职人数/平均在职人数'];

const ZPWCL_DATA = ['招聘留存率=当期入职且现仍在职人数/当期入职人数'];

const YGZB_DATA = ['某等级员工数量占比=此等级员工数量/所有员工数量'];








export default {
    CUSTOMER_DATA,
    RECOMMEND,
    MONTH_COLLECTION,
    EMPLOYEE_DATE,
    COLLECTION_GRDE,
    RESUME_Date,
    COLLECTION_REGION,
    COLLECTION_INDUSTRY,
    COLLECTION_MONEY,
    COLLECTION_CYCLE,
    ACHIEVEMENT_DISTRIBUTION,
    CANDIDATE_RECOMMENDATION,
    RECOMMENDED_FUNNEL,
    BUSINESS_CONSULTANT,
    BUSINESS_EDUCATION,
    BUSINESS_AGE,
    BUSINESS_WORK_YEAR,
    BUSINESS_SEX,
    BUSINESS_HOUSEHOLD_REGISTER,
    MANAGEMENT_STAFF,
    MANAGEMENT_COMPANY,
    MANAGEMENT_GRADE,
    MANAGEMENT_PRICE,
    MANAGEMENT_ALL,
    MANAGEMENT_STAFF_GRADE,
    MANAGEMENT_EDUCATION,
    MANAGEMENT_QUIT,
    MANAGEMENT_INFO,
    YJTB_DATA,
    KDJ_Data,
    ZHL_DATA,
    YSZC_DATA,
    YJWCL_DATA,
    QYGCDB_DATA,
    KHZS_DATA,
    QURYTBZC_DATA,
    QYJZ_DATA,
    RX_DATA,
    JDZPLCL_DATA,
    LZTHL_DATA,
    ZPWCL_DATA,
    YGZB_DATA
}


// WEBPACK FOOTER //
// ./src/constants/index.js